import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import  Slider  from 'react-slick';
import conversations from '../../misc/categoryLandingConversations';
import categoryLandingNewsTaglines from '../../misc/categoryLandingNewsTaglines';
import Image from '../../components/Image';

export default class CategoryConversationSlider extends Component {
  render() {

    let newsTagline = '';
    if (categoryLandingNewsTaglines[this.props.slug]) {
      newsTagline = categoryLandingNewsTaglines[this.props.slug];
    }

    const collection = conversations[this.props.slug];
    const { categoryName, browser } = this.props;
    let slides = [];

    if(!collection) {
      return <h4 style={{margin: 0, padding: 0}}>&nbsp;</h4>;
    }

    slides = collection.map((item, idx) => {
      return <div key={`slide-${idx}`}>
        <a className="item-anchor" target="_blank" rel="noopener" href={item.url}>
          <img src={item.image} alt={`${item.title} - ${item.description}`} className="item-image" />
          <div className="item-title-description-container">
            <div className="item-title">{item.title}</div>
            <div className="item-description">{item.description}</div>
            <div className="item-via">Via {item.via}</div>
          </div>
        </a>
      </div>;
    });

    if(slides.length == 0) {
    }

    let settings = {
      autoplay: false,
      infinite: true,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    };

    if(browser.greaterThan.phablet) {
      settings.slidesToShow = 2;
      settings.slidesToScroll = 1;
    }

    if(browser.greaterThan.tablet) {
      settings.slidesToShow = 4;
      settings.slidesToScroll = 4;
    }



    return <div className="categoryDetail-conversationSlider">
      <h4>{categoryName}: What's new?</h4>
      <p>{newsTagline.tagline}</p>
      <Slider { ...settings }>{slides}</Slider>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/categoryDetailLandingPage/CategoryConversationSlider.jsx